import { Component } from "solid-js";

interface OneStopShopsIconProps {
  class?: string;
}

export const OneStopShopsIcon: Component<OneStopShopsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M5.33325 9.33331V6.66665C5.33325 5.93027 5.93021 5.33331 6.66659 5.33331H25.3333C26.0696 5.33331 26.6666 5.93027 26.6666 6.66665V9.33331"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.6667 9.33331H5.33333C4.59695 9.33331 4 9.93027 4 10.6666V25.3333C4 26.8061 5.19391 28 6.66667 28H25.3333C26.8061 28 28 26.8061 28 25.3333V10.6666C28 9.93027 27.403 9.33331 26.6667 9.33331Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.3334 14.6667C21.3334 17.6122 18.9456 20 16.0001 20C13.0546 20 10.6667 17.6122 10.6667 14.6667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
